<div class="page__content">
    <div class="content__inner">
        <div *ngIf="currentUser">
            <!--p><strong>Usuario:</strong> {{ currentUser.nombre }}</p>

            <p><strong>Email:</strong> {{ currentUser.email }}</p-->
            <div class="row">
                <div class="col-lg-7 d-flex justify-content-around personal-data">
                    <div class="iconName rounded-circle" style="width: 100px; height: 100px; margin-right: 10px;">
                        <p>{{getFirstLetter(this.currentUser.nombre)}}{{getFirstLetter(this.currentUser.apellido1)}}</p>
                    </div>
                    <div>
                        <b>{{this.currentUser.nombre}} {{this.currentUser.apellido1}}</b>
                        <p>{{this.currentUser.email}}</p>
                        <!-- <input autocomplete="off" type="text"  value="{{this.email}}" class="form-control" />-->
                        <div class="form-group">
                            <form [formGroup]="form2" (click)="openDeleteDialog()" class="centerButton"
                                *ngIf="this.currentUser.email != null">
                                <button type="submit" class="btn btn-primary">{{ 'PROFILE.DEACTIVATE' | translate }}</button>
                            </form>
                        </div>
                    </div>

                </div>
                <div class="col-lg-5 profile-2fa-panel" *ngIf="currentUser.email">
                    <div *ngIf="!tfActivated && !isShown && !loading" class="tfa-status">
                        <p class="tfa-status__label">{{ 'PROFILE.TFA_LABEL' | translate }}</p>
                        <div class="tfa-status__row">
                            <span class="tfa-badge tfa-badge--off">{{ 'PROFILE.TFA_INACTIVE' | translate }}</span>
                            <form [formGroup]="form2" (ngSubmit)="pedirQR()">
                                <button type="submit" class="btn btn-primary">{{ 'PROFILE.ACTIVATE_2FA' | translate }}</button>
                            </form>
                        </div>
                    </div>

                    <div *ngIf="loading" class="tfa-setup__loading">
                        <div class="spinner-border spinner-border-sm" role="status"></div>
                        <span>{{ 'COMMON.LOADING' | translate }}</span>
                    </div>

                    <div *ngIf="!tfActivated && isShown && !loading" class="tfa-setup">
                        <button type="button" class="tfa-setup__close" (click)="cerrarActivacion2FA()"
                            [attr.aria-label]="'PROFILE.TFA_CLOSE' | translate" [attr.title]="'PROFILE.TFA_CLOSE' | translate">×</button>
                        <p class="tfa-setup__intro">{{ 'PROFILE.TFA_SCAN_QR' | translate }}</p>
                        <div class="tfa-setup__qr">
                            <img *ngIf="qrImageUrl" [src]="qrImageUrl" alt="QR Authenticator" (error)="onQrImageError()" />
                        </div>
                        <form [formGroup]="form3" (ngSubmit)="guardarQR()" *ngIf="qr?.secret" class="tfa-setup__form">
                            <label class="form-label" for="profile-totp">{{ 'PLACEHOLDER.CODIGO_GENERADO' | translate }}</label>
                            <input id="profile-totp" type="text" autocomplete="one-time-code" formControlName="totpkey"
                                class="form-control tfa-setup__otp" placeholder="000000" maxlength="6" inputmode="numeric"
                                [ngClass]="{'is-invalid': errorQR}" />
                            <button type="submit" class="btn btn-primary">{{ 'PROFILE.ACTIVATE_2FA' | translate }}</button>
                        </form>
                        <div *ngIf="errorQR" class="tfa-setup__alert">
                            <p>{{ 'PROFILE.TFA_ERROR' | translate }}</p>
                        </div>
                    </div>

                    <div *ngIf="tfActivated" class="tfa-status">
                        <p class="tfa-status__label">{{ 'PROFILE.TFA_LABEL' | translate }}</p>
                        <div class="tfa-status__row">
                            <span class="tfa-badge tfa-badge--on">{{ 'PROFILE.TFA_ACTIVE' | translate }}</span>
                            <form [formGroup]="form3" (ngSubmit)="quitarQR()">
                                <button type="submit" class="btn btn-outline-primary">{{ 'PROFILE.DEACTIVATE_2FA' | translate }}</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row">
                <form *ngIf="!isSuccessful" name="form" (ngSubmit)="onSubmit()" [formGroup]="form" novalidate>
                    <div class="row pt-4 p-2" *ngIf="this.currentUser.tipopersona.id == '2'">
                        <div class="col-sm-12">
                            <h6>{{ 'PROFILE.COMPANY_DATA' | translate }}</h6>
                        </div>
                        <div class="border row p-3" style="flex: auto">
                            <div class="col-sm-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.RAZON_SOCIAL' | translate }}</label>
                                <input autocomplete="off" type="text" class="form-control" name="nombre"
                                    [formControlName]="'nombre'" minlength="3" maxlength="20" [attr.disabled]="'true'"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['nombre'].errors}" />
                            </div>
                            <div class="col-sm-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.TIPO_DE_PERSONA' | translate }}</label>
                                <select class="form-control" [formControlName]="'tipo_persona'" [attr.disabled]="'true'"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['tipo_persona'].errors}">
                                    <option *ngFor="let tipopersona of TPersonas" [value]="tipopersona.id">
                                        {{ tipopersona.nombre }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-3 ">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.TIPO_DE_DOCUMENTO' | translate }}</label>
                                <select class="form-control" [formControlName]="'tipo_documento'"
                                    [attr.disabled]="'true'"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['tipo_documento'].errors}">
                                    <option *ngFor="let tipodocumento of TDocumentos" [value]="tipodocumento.id">
                                        {{ tipodocumento.nombre }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.N_DE_DOCUMENTO' | translate }}</label>
                                <input autocomplete="off" name="numero_documento"
                                    class="w-100 text-align-center form-control" [formControlName]="'numero_documento'"
                                    [attr.disabled]="'true'"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['numero_documento'].errors}" />
                            </div>

                        </div>
                    </div>
                    <div class="row pt-4 p-2"
                        *ngIf="this.currentUser.tipopersona.id != '2' ||  this.currentUser.usuarioRepresenta?.numeroDocumento">
                        <div class="col-sm-12">
                            <h6>{{ (this.currentUser.tipopersona.id == '2' ? 'PROFILE.RESPONSIBLE_DATA' : 'PROFILE.PERSONAL_DATA') | translate }}</h6>
                        </div>
                        <div class="border row p-3">
                            <div class="col-sm-4">
                                <label class="requerido">{{ 'REGISTER.NAME' | translate }}</label>
                                <input autocomplete="off" type="text" class="form-control" name="nombre"
                                    [formControlName]="this.currentUser.tipopersona.id == '2' ? 'nombre_responsable' :'nombre'"
                                    minlength="3" maxlength="20" [attr.disabled]="'true'"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['nombre'].errors}" />
                            </div>

                            <div class="col-sm-4">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.PRIMER_APELLIDO' | translate }}</label>
                                <input autocomplete="off" type="text" class="form-control" name="apellido1"
                                    [formControlName]="this.currentUser.tipopersona.id == '2' ? 'apellido1_responsable' : 'apellido1'"
                                    minlength="3" maxlength="20" [attr.disabled]="'true'"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['apellido1'].errors}" />
                            </div>

                            <div class="col-sm-4">
                                <label>{{ 'REGISTER.SECOND_NAME' | translate }}</label>
                                <input autocomplete="off" type="text" class="form-control" name="apellido2"
                                    [formControlName]="this.currentUser.tipopersona.id == '2' ? 'apellido2_responsable' : 'apellido2'"
                                    minlength="3" maxlength="20" [attr.disabled]="'true'"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['apellido2'].errors}" />
                            </div>
                            <div class="col-sm-4 mt-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.TIPO_DE_PERSONA' | translate }}</label>
                                <select class="form-control"
                                    [formControlName]="this.currentUser.tipopersona.id == '2' ? 'tipo_persona_responsable' : 'tipo_persona'"
                                    [attr.disabled]="'true'"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['tipo_persona'].errors}">
                                    <option *ngFor="let tipopersona of TPersonas" [value]="tipopersona.id">
                                        {{ tipopersona.nombre }}
                                    </option>
                                </select>
                            </div>

                            <div class="col-sm-4 mt-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.TIPO_DE_DOCUMENTO' | translate }}</label>
                                <select class="form-control"
                                    [formControlName]="this.currentUser.tipopersona.id == '2' ? 'tipo_documento_responsable' : 'tipo_documento' "
                                    [attr.disabled]="'true'"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['tipo_documento'].errors}">
                                    <option *ngFor="let tipodocumento of TDocumentos" [value]="tipodocumento.id">
                                        {{ tipodocumento.nombre }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-4 mt-3 mb-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.N_DE_DOCUMENTO' | translate }}</label>
                                <input autocomplete="off" name="numero_documento"
                                    class="w-100 text-align-center form-control"
                                    [formControlName]="this.currentUser.tipopersona.id == '2' ? 'numero_documento_responsable' : 'numero_documento' "
                                    [attr.disabled]="'true'"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['numero_documento'].errors}" />
                            </div>
                        </div>
                    </div>
                    <div class="row mt-4 mb-3 p-2">
                        <div class="col-sm-12">
                            <h6>{{ 'REGISTER.CONTACT_DATA' | translate }}</h6>
                        </div>
                        <div class="border row  p-3">
                            <div class="col-sm-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.TIPO_DE_VIA' | translate }}</label>
                                <select formControlName="tipo_via" class="form-control"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['tipo_via'].errors}">
                                    <option *ngFor="let vias of TVias" [value]="vias.id">
                                        {{ vias.tipovianormalizado }}
                                    </option>
                                </select>
                            </div>

                            <div class="col-sm-6">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.DIRECCION' | translate }}</label>
                                <input autocomplete="off" type="text" formControlName="nombre_via" class="form-control"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['nombre_via'].errors}" />
                            </div>


                            <div class="col-sm-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.N_DE_LA_VIA' | translate }}</label>
                                <input autocomplete="off" type="text" formControlName="numero_via" class="form-control"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['numero_via'].errors}" />
                            </div>

                            <div class="col-sm-3 mt-3">
                                <label>{{ 'TRAMITE.FORM.LABEL.BLOQUE' | translate }}</label>
                                <input autocomplete="off" type="text" formControlName="bloque" class="form-control" />
                            </div>

                            <div class="col-sm-3 mt-3">
                                <label>{{ 'TRAMITE.FORM.LABEL.ESCALERA' | translate }}</label>
                                <input autocomplete="off" type="text" formControlName="escalera" class="form-control" />
                            </div>

                            <div class="col-sm-3 mt-3">
                                <label>{{ 'TRAMITE.FORM.LABEL.PISO' | translate }}</label>
                                <input autocomplete="off" type="text" formControlName="piso" class="form-control" />
                            </div>

                            <div class="col-sm-3 mt-3">
                                <label>{{ 'TRAMITE.FORM.LABEL.PUERTA' | translate }}</label>
                                <input autocomplete="off" type="text" formControlName="puerta" class="form-control" />
                            </div>

                            <div class="col-sm-4 mt-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.PAIS' | translate }}</label>
                                <select formControlName="pais" class="form-control"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['pais'].errors}">
                                    <option *ngFor="let _pais of TPais" [value]="_pais.id">
                                        {{ _pais.nombre }}
                                    </option>
                                </select>
                            </div>

                            <div class="col-sm-4 mt-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.COMUNIDAD' | translate }}</label>
                                <select formControlName="ccaa" class="form-control" (change)="onChangeProvincia($event)"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['ccaa'].errors}">
                                    <option *ngFor="let ccaa of TComunidades" [value]="ccaa.id">
                                        {{ ccaa.nombre }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-4 mt-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.PROVINCIA' | translate }}</label>
                                <select formControlName="provincia" class="form-control"
                                    (change)="onChangeMunicipio($event)"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['provincia'].errors}">
                                    <option *ngFor="let provincia of TProvincias" [value]="provincia.id">
                                        {{ provincia.nombre }}
                                    </option>
                                </select>
                            </div>

                            <div class="col-sm-4 mt-3 mb-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.MUNICIPIO' | translate }}</label>
                                <select formControlName="municipio" class="form-control"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['municipio'].errors}">
                                    <option *ngFor="let municipio of TMunicipios"
                                        [value]="municipio.municipioPK['municipio_id']">
                                        {{ municipio.nombre }}
                                    </option>
                                </select>
                            </div>
                            <div class="col-sm-4 mt-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.CODIGO_POSTAL' | translate }}</label>
                                <input autocomplete="off" type="text" mask="9{5}" formControlName="codigo_postal"
                                    class="form-control"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['codigo_postal'].errors}" />
                            </div>
                            <div class="col-sm-4 mt-3">
                                <label class="requerido">{{ 'TRAMITE.FORM.LABEL.TELEFONO_MOVIL' | translate }}</label>
                                <input autocomplete="off" type="text" class="form-control" name="telefono"
                                    formControlName="telefono"
                                    [ngClass]="{'is-invalid': submitted && this.form.controls['telefono'].errors}" />
                            </div>
                            <div class="w-100 p-3" style="background-color:var(--blue-pale); margin-top:2rem !important"
                                *ngIf="this.currentUser.email!=null">
                                <div class="row">
                                    <div class="col-sm-12 mt-1">
                                        <label class="requerido">{{ 'PLACEHOLDER.EMAIL' | translate }}</label>
                                        <input autocomplete="off" type="email" name="email" class="form-control"
                                            formControlName="email" placeholder="{{this.currentUser.email}}"
                                            [ngClass]="{'is-invalid': submitted && this.form.controls['email'].errors}" />
                                    </div>
                                </div>
                            </div>
                            <div class="w-100 p-3" style="background-color:var(--blue-pale); margin-top:2rem !important"
                                *ngIf="this.currentUser.email==null">
                                <div class="row">
                                    <div class="col-sm-12 mt-1">
                                        <label class="requerido">{{ 'PLACEHOLDER.EMAIL' | translate }}</label>
                                        <input autocomplete="off" type="email" name="email" class="form-control"
                                            formControlName="email"
                                            [ngClass]="{'is-invalid': submitted && this.form.controls['email'].errors}" />
                                    </div>

                                    <!-- Se comenta para eliminar el campo contraseña al actualizar el usuario -->
                                    <!-- <div class="col-sm-4 mt-1">
                                        <label class="requerido">{{ 'PLACEHOLDER.CONTRASENA' | translate }}</label>
                                        <input autocomplete="off" type="password" class="form-control" name="password" formControlName="password"
                                            minlength="6"
                                            [ngClass]="{'is-invalid': submitted && this.form.controls['password'].errors}" />
                                    </div>
                                    <div class="col-sm-4 mt-1">
                                        <label class="requerido">{{ 'TRAMITE.FORM.LABEL.CONFIRMAR_CONTRASENA' | translate }}</label>
                                        <input autocomplete="off" type="password" class="form-control" name="password_confirmacion"
                                            formControlName="password_confirmacion" minlength="6"
                                            [ngClass]="{'is-invalid': submitted && this.form.controls['password_confirmacion'].errors}" />
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                    <h6 class="data_required">{{ 'PROFILE.REQUIRED_DATA_HINT' | translate }}</h6>
                    <p>{{ 'PROFILE.UPDATE_INSTRUCTIONS' | translate }}</p>
                    <div class="alertPuestos">
                        <img src="assets/triangle-exclamation.svg" class="iconAlert" />
                        <b>{{ 'PROFILE.PHONE_EMAIL_WARNING' | translate }}</b> {{ 'PROFILE.PHONE_EMAIL_WARNING_DETAIL' | translate }}
                    </div>
                    <div class="w-100 d-flex pr-3"
                        [class]="this.currentUser.email == null || this.currentUser.email_confirmado || this.currentUser.email_confirmado == null? 'justify-content-end' : 'justify-content-between'">
                        <button
                            *ngIf="!this.currentUser.email_confirmado && this.currentUser.email_confirmado != null && this.currentUser.email != null"
                            type="button" class="btn btn-primary" (click)="reenviarCorreo()"
                            [disabled]="blockEnvioCorreo? 'true' : null">{{ 'CONFIRM_EMAIL.RESEND' | translate }}</button>

                        <button type="submit" class="btn btn-primary" [attr.disabled]="update?'':null">
                            {{ 'PROFILE.UPDATE_BUTTON' | translate }}
                        </button>
                    </div>
                </form>
            </div>
        </div>

        <ng-template #loggedOut>{{ 'PROFILE.LOGGED_OUT' | translate }}</ng-template>
    </div>
</div>